"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blobToArrayBuffer;

function blobToArrayBuffer(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onerror = function (_ref) {
      var error = _ref.error,
          message = _ref.message;
      return reject(error || new Error(message));
    };

    reader.onloadend = function () {
      return resolve(reader.result);
    };

    reader.readAsArrayBuffer(file);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJibG9iVG9BcnJheUJ1ZmZlciIsImZpbGUiLCJQcm9taXNlIiwicmVzb2x2ZSIsInJlamVjdCIsInJlYWRlciIsIkZpbGVSZWFkZXIiLCJvbmVycm9yIiwiZXJyb3IiLCJtZXNzYWdlIiwiRXJyb3IiLCJvbmxvYWRlbmQiLCJyZXN1bHQiLCJyZWFkQXNBcnJheUJ1ZmZlciJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1V0aWxzL2Rvd25zY2FsZUltYWdlVG9EYXRhVVJML2Jsb2JUb0FycmF5QnVmZmVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGJsb2JUb0FycmF5QnVmZmVyKGZpbGUpIHtcbiAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICBjb25zdCByZWFkZXIgPSBuZXcgRmlsZVJlYWRlcigpO1xuXG4gICAgcmVhZGVyLm9uZXJyb3IgPSAoeyBlcnJvciwgbWVzc2FnZSB9KSA9PiByZWplY3QoZXJyb3IgfHwgbmV3IEVycm9yKG1lc3NhZ2UpKTtcbiAgICByZWFkZXIub25sb2FkZW5kID0gKCkgPT4gcmVzb2x2ZShyZWFkZXIucmVzdWx0KTtcbiAgICByZWFkZXIucmVhZEFzQXJyYXlCdWZmZXIoZmlsZSk7XG4gIH0pO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsaUJBQVQsQ0FBMkJDLElBQTNCLEVBQWlDO0VBQzlDLE9BQU8sSUFBSUMsT0FBSixDQUFZLFVBQUNDLE9BQUQsRUFBVUMsTUFBVixFQUFxQjtJQUN0QyxJQUFNQyxNQUFNLEdBQUcsSUFBSUMsVUFBSixFQUFmOztJQUVBRCxNQUFNLENBQUNFLE9BQVAsR0FBaUI7TUFBQSxJQUFHQyxLQUFILFFBQUdBLEtBQUg7TUFBQSxJQUFVQyxPQUFWLFFBQVVBLE9BQVY7TUFBQSxPQUF3QkwsTUFBTSxDQUFDSSxLQUFLLElBQUksSUFBSUUsS0FBSixDQUFVRCxPQUFWLENBQVYsQ0FBOUI7SUFBQSxDQUFqQjs7SUFDQUosTUFBTSxDQUFDTSxTQUFQLEdBQW1CO01BQUEsT0FBTVIsT0FBTyxDQUFDRSxNQUFNLENBQUNPLE1BQVIsQ0FBYjtJQUFBLENBQW5COztJQUNBUCxNQUFNLENBQUNRLGlCQUFQLENBQXlCWixJQUF6QjtFQUNELENBTk0sQ0FBUDtBQU9EIn0=